import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { round_add_staff_shift_cycle } from 'api/Attendance';
export default {
  data: function data() {
    return {
      visible: false,
      loading: false,
      // 提交按钮loading
      ruleForm: {
        id: '',
        month: new Date(),
        // 限制月份
        is_before: false,
        // 必须是否此日期之前也按照相应规律排班，
        start_date: '' // 开始时间
      } // 表单
    };
  },

  methods: {
    init: function init(params) {
      var id = params.id,
        date = params.date;
      this.ruleForm.month = date;
      this.ruleForm.id = id;
      this.visible = true;
      this.generateDate(date);
    },
    // 如果是当前月 则展示当天 其他展示1号
    generateDate: function generateDate(date) {
      var currentDate = new Date();
      if (date.getMonth() === currentDate.getMonth()) {
        this.ruleForm.start_date = this.$util.parseTime(currentDate, '{y}-{m}-{d}');
      } else {
        var targetDate = new Date(date.getFullYear(), date.getMonth(), 1);
        this.ruleForm.start_date = this.$util.parseTime(targetDate, '{y}-{m}-{d}');
      }
    },
    // 时间选择禁用 必须是当前月
    disabledDate: function disabledDate(t) {
      var month = this.ruleForm.month;
      var nextMonth = new Date(month.getFullYear(), month.getMonth() + 1, 1);
      return t.getTime() < month.getTime() || t.getTime() >= nextMonth.getTime();
    },
    // 日期格式补全
    createNum: function createNum(num) {
      return num < 10 ? "0".concat(num) : num;
    },
    doSubmint: function doSubmint() {
      var _this = this;
      var month = this.ruleForm.month;
      var m = this.createNum(month.getMonth() + 1);
      var msg = _objectSpread(_objectSpread({}, this.ruleForm), {}, {
        month: "".concat(month.getFullYear(), "-").concat(m)
      });
      round_add_staff_shift_cycle(msg).then(function (res) {
        _this.visible = false;
        _this.$emit('update');
      });
    }
  }
};